import Yup from '_zari/validation/_yup'

const validationSchema = Yup.object().shape({
  _idSocio: Yup.string().required(),
  _idTituloViatico: Yup.string().required(),
  cuentaContableDebe: Yup.string().required(),
  cuentaContableHaber: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  flujoEfectivo: Yup.string().required(),
  glosa: Yup.string().required(),
  importe: Yup.string().required(),
  medioPago: Yup.string().required(),
  moneda: Yup.string().required(),
  numeroDocumentoPago: Yup.string().required()
})

export default validationSchema
